import { Box, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { useMemo } from 'react';
import { useParams } from 'react-router';
import useLocales from '../../hooks/useLocales';
import useInterval from '../../hooks/useInterval';
import { getFakePlayerStats } from '../../redux/slices/lookup';
import Image from '../../components/Image';
import { useSelector } from '../../redux/store';
import { fNumber } from '../../utils/formatNumber';

const TableCellNoBg = styled(TableCell)(({ theme }) => ({
  background: 'none',
  color: '#fff',
  fontSize: '10px',
  textAlign: 'start',
  [theme.breakpoints.up('sm')]: {
    fontSize: '12px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '14px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '17px',
  },
}));

const HomeLeaderboard = () => {
  const { translate } = useLocales();

  const { fakePlayerStats } = useSelector((x) => x.lookup);

  const fake10 = useMemo(() => {
    if (fakePlayerStats?.length) {
      const sortedData = [...fakePlayerStats].sort((a, b) => b.win - a.win);
      return sortedData.slice(0, 10);
    }

    return [];
  }, [fakePlayerStats]);

  useInterval(getFakePlayerStats, 60000);

  return (
    <TableContainer>
      <Table sx={{ width: '100%' }} size="small">
        <TableHead sx={{ py: 1 }}>
          <TableRow sx={{ backgroundColor: 'rgb(45, 3, 3)' }}>
            <TableCellNoBg>{translate('username')}</TableCellNoBg>

            <TableCellNoBg sx={{ minWidth: '90px', textAlign: 'center' }}>{translate('game_name')}</TableCellNoBg>

            <TableCellNoBg>{translate('winnings')}</TableCellNoBg>
          </TableRow>
        </TableHead>

        <TableBody>
          {fake10?.map((x, idx) => (
            <TableRow key={idx} sx={{ background: (idx + 1) % 2 === 0 ? '#840000' : '#AF001E' }}>
              <TableCellNoBg>{x.username}</TableCellNoBg>
              <TableCellNoBg
                sx={{
                  display: 'flex',
                  gap: 1,
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontWeight: 900,
                }}
              >
                <Box sx={{ width: '10%', display: { xs: 'none', sm: 'none', md: 'block' } }}>
                  <Image src={x.game_photo_url} sx={{ width: '100%' }} />
                </Box>
                <Box
                  sx={{
                    width: { xs: '100%', sm: '100%', md: '30%' },
                    textAlign: { xs: 'center', sm: 'center', md: 'start' },
                  }}
                >
                  {x.game_name}
                </Box>
              </TableCellNoBg>
              <TableCellNoBg>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>{fNumber(x?.win || 0)}</span>
                  {/* <Box sx={{ width: '30%' }}>
                    <Image src={require('../../assets/home/leaderboard-play.png')} sx={{ width: '100%' }} />
                  </Box> */}
                </Box>
              </TableCellNoBg>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default HomeLeaderboard;
